import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import UserLayout from "./routes/middleware/UserLayout";
import { userRoutes } from "./routes/AllRoutes";
import { Toaster } from "react-hot-toast";
import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
      offset: 90,
    });

    AOS.refresh();
  }, []);

  const renderUserRoutes = (routes) =>
    routes.map((route, index) => {
      if (route.children) {
        return (
          <Route key={index} path={route.path} element={<UserLayout />}>
            {route.children.map((child, index) => (
              <Route key={index} path={child.path} element={child.element} />
            ))}
          </Route>
        );
      }
      return (
        <Route
          key={index}
          path={route.path}
          element={<UserLayout UserLayout> {route.element}</UserLayout>}
        />
      );
    });

  return (
    <>
      <BrowserRouter>
        <div>
          <Routes>{renderUserRoutes(userRoutes)}</Routes>
          <Toaster position="top-center"></Toaster>
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;
